module.exports = __webpack_public_path__ + "static/media/01ilustracion.49782f82.png";